// extracted by mini-css-extract-plugin
export default {"modal-seat":"style_modal-seat__0jZ1i","close":"style_close__rg9Ix"};